<template>
	<!-- 咨询建议 弹窗开始 -->
	<div class="explain" id="message" :style="{'margin-right':isdetailopen?'700px':'0px','width': isdetailopen?'calc(100% - 700px)':''}">
	  <div class="rightWap">
	    <div class="message">
	      <h1>咨询建议<img src="/images/rightClose.png" class="closePop" @click="closeFloat"/></h1>
	      <ul class="tab1">
	        <li id="a1" @click="zixunjianyiColum=0" :class="zixunjianyiColum==0?'curr':''"><span style="font-size: 16px">需求咨询</span></li>
	        <li id="a2" @click="zixunjianyiColum=1" :class="zixunjianyiColum==1?'curr':''"><span style="font-size: 16px">意见反馈</span></li>
	      </ul>
	      <div class="tabContent">
	        <div id="con_a_1" v-show="zixunjianyiColum==0">
	          <dl class="messageForm">
	            <dt><i>*</i>所需资料的详细描述</dt>
	            <dd>
	              <div class="textareaWap"><textarea v-model="zixunform.desc" placeholder="请详细描述您的资料需求，我们将竭力为您服务！" rows="10" maxlength="300" style="resize: none;"></textarea></div>
	              <span style="position: absolute; right: 24px; bottom: 24px; ">{{zixunform.desc.length}}/300</span>
	            </dd>
	            <dt><i>*</i>邮箱</dt>
	            <dd><input type="text" placeholder="example@example.com" v-model="zixunform.email"/></dd>
	            <dt><i></i>联系电话</dt>
	            <dd><input type="text" placeholder="固话请输入区号-电话号" maxlength="13" v-model="zixunform.phone"/></dd>
	          </dl>
	          <div style="text-align: right"><input type="button" @click="addzixun" value="提交" class="messageSub"/></div>
	          <h2 v-show="zixuntotalResultCount"><span>需求咨询历史</span></h2>
	          <div v-show="zixuntotalResultCount" class="histroy">
	            <div v-for="(item,index) in zixunresultDataList" class="messageHistroy">
	              <div class="date">
	                <span>{{item.updatetime.substring(8,10)}}</span>
	                <em>{{item.updatetime.substring(0,7)}}</em>
	              </div>
	              <i>咨询内容</i>
	              <ul>
	                <li>{{JSON.parse(item.content)&&JSON.parse(item.content).desc?JSON.parse(item.content).desc:''}}<a @click="showzixunDetail(item.id)" class="more1">【详情】</a></li>
	              </ul>
	            </div>
	            <!-- <div class="messageHistroy">
	              <div class="date">
	                <span>15</span>
	                <em>2022/03</em>
	              </div>
	              <i>咨询内容</i>
	              <ul>
	                <li>{{JSON.parse(item.content)&&JSON.parse(item.content).desc?JSON.parse(item.content).desc:''}}<a @click="showzixunDetail(item.id)" class="more1">【详情】</a></li>
	              </ul>
	            </div> -->
	          </div>
	          <div class="pagediv" style="margin-top: 80px;" v-show="zixuntotalResultCount">
	          	<el-pagination @current-change="changeZixunPage" :current-page="zixunpageNum"
	          		:page-size="5" layout="prev, pager, next"
	          		:total="zixuntotalResultCount">
	          	</el-pagination>
	          </div>
	        </div>
	        <div id="con_a_2" v-show="zixunjianyiColum==1">
	          <dl class="messageForm">
	            <dt><i>*</i>请选择反馈类型</dt>
	            <dd>
	              <input v-model="fankuiform.type" value="功能异常" type="radio" name="a" style="margin-left: 20px"/> 功能异常
								<input v-model="fankuiform.type" value="产品建议" type="radio" name="a" style="margin-left: 40px"/> 产品建议
								<input v-model="fankuiform.type" value="其他" type="radio" name="a" style="margin-left: 40px"/> 其他
	            </dd>
	            <dt><i>*</i>请详细描述您的问题</dt>
	            <dd>
	              <div class="textareaWap">
	                <textarea placeholder="请详细描述您的问题，我们将竭力为您服务！" v-model="fankuiform.desc"></textarea>
	                <div style="text-align: right; padding-right: 24px;"><span>{{fankuiform.desc.length}}/300</span></div>
	                <div style="padding: 24px">
										<div style="position: relative;">
											<img src="/images/photo.png"/>
											<input type="file" id="file" accept="image/*" v-on:change="uploadFile" style="opacity: 0;width: 80px;height: 80px;cursor: pointer;position: absolute;left: 0;"/>
										</div>
										<div v-for="(item,index) in fankuiatts" class="pic" style="position: relative;">
											<img v-bind:src="item.image"  style="max-width: 100%;"  alt=""/>
											<img src="/images/rightClose.png" @click="delFile(item.attId)" style="position: absolute;left: 16px;top: 16px;"/>
										</div>
	                  <div style="color: #d9d9d9; padding-top: 24px;">单张图片最大可上传大小为1MB</div>
	                </div>
	              </div>
	            </dd>
	            <dt><i></i>联系电话</dt>
	            <dd><input type="text" placeholder="联系电话/邮箱地址" v-model="fankuiform.phone"/></dd>
	          </dl>
	          <div style="text-align: right"><input type="button" value="提交" @click="addfankui" class="messageSub"/></div>
	          <h2 v-show="fankuitotalResultCount"><span>建议反馈历史</span></h2>
	          <div class="histroy" style="margin-top: 30px" v-show="fankuitotalResultCount">
	            <div v-for="(item,index) in fankuiresultDataList" class="messageHistroy">
	              <div class="date" style="top: -30px">
	                <span>{{item.updatetime.substring(8,10)}}</span>
	                <em>{{item.updatetime.substring(0,7)}}</em>
	              </div>
	              <div class="type"><strong>反馈类型</strong>{{JSON.parse(item.content)&&JSON.parse(item.content).type?JSON.parse(item.content).type:''}}</div>
	              <i>咨询内容</i>
	              <ul>
	                <li style="margin-top: 11px">{{JSON.parse(item.content)&&JSON.parse(item.content).desc?JSON.parse(item.content).desc:''}}<a class="more2" @click="showjianyiDetail(item.id)">【详情】</a></li>
	              </ul>
	            </div>
	            <!-- <div class="messageHistroy">
	              <div class="date" style="top: -30px">
	                <span>15</span>
	                <em>2022/03</em>
	              </div>
	              <div class="type"><strong>反馈类型</strong>产品建议</div>
	              <i>咨询内容</i>
	              <ul>
	                <li style="margin-top: 11px">为什么多部门联合出台政策：促工业经济稳增长 助服务业恢复发展促工业经济稳增长助服务业恢复发展促工业发展发...<a class="more2">【详情】</a></li>
	              </ul>
	            </div> -->
	          </div>
	          <div class="pagediv" style="margin-top: 80px;" v-show="fankuitotalResultCount">
	          	<el-pagination @current-change="changeFankuiPage" :current-page="fankuipageNum"
	          		:page-size="5" layout="prev, pager, next"
	          		:total="fankuitotalResultCount">
	          	</el-pagination>
	          </div>
	        </div>    
	      </div>    
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				loadingMask: false,
				zixunjianyiColum:0,
				zixunform: {
					desc: '',
					email:'',
					phone:''
				},
				zixunpageNum: 1,
				zixunpageSize: 5,
				zixuntotalResultCount: 0,
				zixunresultDataList: [],
				fankuiform: {
					type: '产品建议',
					desc:'',
					phone:''
				},
				fankuiatts:[],
				fankuipageNum: 1,
				fankuipageSize: 5,
				fankuitotalResultCount: 0,
				fankuiresultDataList: [],
			}
		},
		props: [
			'userinfo',
			'isdetailopen',
			'showcolum'
		],
		mounted: function() {
			this.zixunjianyiColum=this.showcolum;
			this.getZixunListfnc();
			this.getFankuiListfnc();
		},
		methods: {
			getZixunListfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstUserFeedback',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							feedbacktype:'1',
							iPageNum: this.zixunpageNum,
							iPageSize: this.zixunpageSize,
						},
					})
					.then(function(response) {
						_this.zixunresultDataList = response.data.data.data.tempResult.artLst;
						_this.zixuntotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype','需求咨询列表']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changeZixunPage: function(page) {
				// console.log(page);
				this.zixunpageNum = page;
				this.getZixunListfnc();
			},
			addzixun:function(){
				if(!this.zixunform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.zixunform.email){
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.zixunform.email){
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(!regemail.test(this.zixunform.email)){
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				if(this.zixunform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					if((!regmobile.test(this.zixunform.phone))&&(!regtel.test(this.zixunform.phone))){
						this.$message({
							message: '请填写正确的联系电话,固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempzixun={
					desc:this.zixunform.desc,
					email:this.zixunform.email,
					phone:this.zixunform.phone
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/AddUserFeedback',
						responseType: 'json',
						params: {
							feedbacktype:1,
							userid: this.userinfo.userAccountID,
							title:'需求咨询'+this.userinfo.userAccountID,
							content: JSON.stringify(tempzixun)
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '需求咨询提交成功',
								type: 'success'
							});
							_this.zixunform.desc='';
							_this.zixunform.email='';
							_this.zixunform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','添加需求咨询']
							]);
						}
						else{
							_this.$message({
								message: '需求咨询提交失败',
								type: 'error'
							});
						}
					})
					.catch(function(error) {
						_this.$message({
							message: '需求咨询提交失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			getFankuiListfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstUserFeedback',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							feedbacktype:'2',
							iPageNum: this.fankuipageNum,
							iPageSize: this.fankuipageSize,
						},
					})
					.then(function(response) {
						_this.fankuiresultDataList = response.data.data.data.tempResult.artLst;
						_this.fankuitotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype','建议反馈列表']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changeFankuiPage: function(page) {
				// console.log(page);
				this.fankuipageNum = page;
				this.getFankuiListfnc();
			},
			addfankui:function(){
				if(!this.fankuiform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.fankuiform.type){
					this.$message({
						message: '请选择类型',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.fankuiform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if((!regmobile.test(this.fankuiform.phone))&&(!regtel.test(this.fankuiform.phone))&&(!regemail.test(this.fankuiform.phone))){
						this.$message({
							message: '请填写正确的联系方式,如邮箱、手机号、固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempfankui={
					type:this.fankuiform.type,
					desc:this.fankuiform.desc,
					phone:this.fankuiform.phone
				}
				var tempAttidArr=[];
				var tempAttnameArr=[];
				for(var i=0;i<this.fankuiatts.length;i++){
					tempAttidArr.push(this.fankuiatts[i].attId);
					tempAttnameArr.push(this.fankuiatts[i].fileName);
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/AddUserFeedback',
						responseType: 'json',
						params: {
							feedbacktype:2,
							userid: this.userinfo.userAccountID,
							title:'建议反馈'+this.userinfo.userAccountID,
							content: JSON.stringify(tempfankui),
							atts:tempAttidArr.length>0?tempAttidArr.join(','):'',
							filenames:tempAttnameArr.length>0?tempAttnameArr.join(','):'',
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '建议反馈提交成功',
								type: 'success'
							});
							_this.fankuiform.desc='';
							// _this.fankuiform.type='';
							_this.fankuiform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','添加建议反馈']
							]);
						}
						else{
							_this.$message({
								message: '建议反馈提交失败',
								type: 'error'
							});
						}
						
					})
					.catch(function(error) {
						_this.$message({
							message: '建议反馈提交失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			uploadFile:function(event){
				if(event.target.files.length>0){
					var upfile=event.target.files[0];
					var formdata=new FormData();
					formdata.append('file',upfile);
					let _this = this;
					this.$http({
							method: 'post',
							url: 'UserInfo/UploadFile',
							data: formdata,
							headers: {
							  'Content-Type': 'multipart/form-data'
							}
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.fankuiatts.push(response.data.data.data);
								_this.$message({
									message: '上传成功',
									type: 'success'
								});
							}
							else{
								_this.$message({
									message: '上传失败:'+response.data.data.msg,
									type: 'error'
								});
							}

						})
						.catch(function(error) {
							_this.$message({
								message: '上传错误:'+response.data.data.msg,
								type: 'error'
							});
							// _this.closeFloat();
							console.log(error);
						});
				}
				
			},
			delFile:function(id){
				for(var i=0;i<this.fankuiatts.length;i++){
					if(this.fankuiatts[i].attId==id){
						this.fankuiatts.splice(i,1);
						break;
					}
				}
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			showzixunDetail: function(id) {
				this.$emit('showzixun',id);
			},
			showjianyiDetail: function(id) {
				this.$emit('showjianyi',id);
			},
		}
	}
</script>

<style>
</style>
